import { render, staticRenderFns } from "./QuotationHistory.vue?vue&type=template&id=51d0dc65&"
import script from "./QuotationHistory.vue?vue&type=script&lang=js&"
export * from "./QuotationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports